import { inject as service } from '@ember/service';
import DS from 'ember-data';
import Route from 'cio/routes/base';

import SnippetController from './controller';
import Snippet from 'cio/models/snippet';

export default class SnippetRoute extends Route {
  @service store!: DS.Store;

  crumb() {
    let model = this.modelFor(this.routeName) as Snippet;

    return {
      name: model.name,
      path: 'snippets.snippet',
      model: model.id,
    };
  }

  model(params: { snippet_id: string }) {
    return this.store.findRecord('snippet', params.snippet_id);
  }

  resetController(controller: SnippetController, isExiting: boolean) {
    if (isExiting) {
      controller.setDefaults();
    }
  }
}
